import React, { Component, Fragment } from 'react'
import { CardBenefits, CardBenefitsMobile } from 'loyal-react'

import Personalite from '@loyal_images/brand/cards-benefits/cards-new/personalite.png'
import SociedadeMesa from '@loyal_images/brand/cards-benefits/img_sociedade_mesa.png'
import Mistral from '@loyal_images/brand/cards-benefits/img_mistral.png'
import Nespresso from '@loyal_images/brand/cards-benefits/img_nespresso.png'
import MediaQuery from 'react-responsive'

class DiscountSuggestion extends Component {
  render () {
    return (
      <Fragment>
        <MediaQuery maxDeviceWidth={425}>
          <CardBenefitsMobile
            link='https://www.iupp.com.br/benefits/listing?profile=pra%20quem%20%C3%A9%20Personnalit%C3%A9'
            name='Personnalité'
            profile='pra quem é Personnalité'
            image={Personalite}
            title='Vai para Personnalité'
            alt='Personnalité'
            titleImg='Imagem Personnalité'
          >
            <span>
              Benefícios para cliente Personnalité
            </span>
          </CardBenefitsMobile>
          <CardBenefitsMobile
            link='https://www.itau.com.br/personnalite/experiencia/gastronomia/sociedade-da-mesa/'
            name='Sociedade da mesa'
            profile='pra quem é Personnalité'
            image={SociedadeMesa}
            title='Vai para Sociedade da mesa'
            alt='Sociedade da mesa'
            titleImg='Imagem Sociedade da mesa'
          >
            <span>Faça parte do clube de vinhos</span>
          </CardBenefitsMobile>
          <CardBenefitsMobile
            link='http://www.mistral.com.br/itaucard'
            name='Mistral'
            profile='pra quem tem Itaucard'
            image={Mistral}
            title='Vai para Mistral'
            alt='Mistral'
            titleImg='Imagem Mistral'
          >
            <span>Até 20% de desconto<br />em até 7x sem juros</span>
          </CardBenefitsMobile>
          <CardBenefitsMobile
            link='https://www.nespressobenefits.com.br/'
            name='Nespresso'
            profile='pra quem tem Itaucard'
            image={Nespresso}
            title='Vai para Nespresso'
            alt='Nespresso'
            titleImg='Imagem Nespresso'
          >
            <span>20% off com <br /> o cupom it0615</span>
          </CardBenefitsMobile>
        </MediaQuery>
        <MediaQuery minDeviceWidth={426}>
          <CardBenefits
            link='https://www.iupp.com.br/benefits/listing?profile=pra%20quem%20%C3%A9%20Personnalit%C3%A9'
            name='Personalite'
            profile='pra quem é Personnalité'
            image={Personalite}
            title='Vai para Personnalité'
            alt='Personnalité'
            titleImg='Imagem Personnalité'
          >
            <span>
              Benefícios para cliente Personnalité
            </span>
          </CardBenefits>
          <CardBenefits
            link='https://www.itau.com.br/personnalite/experiencia/gastronomia/sociedade-da-mesa/'
            name='Sociedade da mesa'
            profile='pra quem é Personnalité'
            image={SociedadeMesa}
            title='Vai para Sociedade da mesa'
            alt='Sociedade da mesa'
            titleImg='Imagem Sociedade da mesa'
          >
            <span>Faça parte do clube de vinhos</span>
          </CardBenefits>
          <CardBenefits
            link='http://www.mistral.com.br/itaucard'
            name='Mistral'
            profile='pra quem tem Itaucard'
            image={Mistral}
            title='Vai para Mistral'
            alt='Mistral'
            titleImg='Imagem Mistral'
          >
            <span>Até 20% de desconto<br />em até 7x sem juros</span>
          </CardBenefits>
          <CardBenefits
            link='https://www.nespressobenefits.com.br/'
            name='Nespresso'
            profile='pra quem tem Itaucard'
            image={Nespresso}
            title='Vai para Nespresso'
            alt='Nespresso'
            titleImg='Imagem Nespresso'
          >
            <span>20% off com <br /> o cupom it0615</span>
          </CardBenefits>
          <CardBenefits link='' name='' description='' image='' />
        </MediaQuery>
      </Fragment>
    )
  }
}

export default DiscountSuggestion



// WEBPACK FOOTER //
// ./src/features/Benefits/DiscountSuggestion/DiscountSuggestion.js